import axios from "axios";

export const fetchObjects = async (
    url: string,
    ogAccessPoint: string | null,
    ogToken: string | null
): Promise<any> => {

    if (!ogAccessPoint) {
        console.error('fetchObjects error. ogAccessPoint  cannot be null');
        throw new Error('fetchObjects error: AccessPoint is null');
    }

    if (!ogToken) {
        console.error('fetchObjects error. ogToken  cannot be null');
        throw new Error('fetchObjects error: ogToken is null');
    }

    try {
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'X-ObjectsGrid-AccessPoint': ogAccessPoint,
                'Authorization': `Bearer ${ogToken}`,
            },
        });

        console.log('Response from fetchObjects:', response.data);
        return response.data;
    } catch (error) {
        console.error('fetchObjects failed:', error);
        throw error;
    }
};

export const createObject = async (
    createUrl: string,
    ogAccessPoint: string | null,
    ogToken: string | null,
    newObject: any
): Promise<any> => {

    try {
        const response = await axios.post(createUrl,
            newObject,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-ObjectsGrid-AccessPoint': ogAccessPoint,
                    'Authorization': `Bearer ${ogToken}`
                }
            })

        console.log('Response from createObject:', response.data);
        return response.data;
    } catch (error) {
        console.error('createObject failed:', error);
        throw error;
    }

}

export const deleteFromObjectsGrid = async (
    cdeleteUrl: string,
    ogAccessPoint: string | null,
    ogToken: string | null,
): Promise<any> => {

    try {

        const response = await axios.delete(cdeleteUrl,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-ObjectsGrid-AccessPoint': ogAccessPoint,
                    'Authorization': `Bearer ${ogToken}`
                }
            })
        console.log('Response from deleteObject:', response.data);
        return response.data;
    } catch (error) {
        console.error('deleteObject failed:', error);
        throw error;
    }

}